import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Database, CheckCircle, AlertTriangle, FileWarning, Clock } from "lucide-react";

export function DataHealthTab() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold mb-2">Data Health</h2>
        <p className="text-muted-foreground">Monitor data quality and integrity</p>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card className="p-6">
          <div className="flex items-start justify-between mb-3">
            <div className="p-3 rounded-xl bg-success/10">
              <CheckCircle className="w-6 h-6 text-success" />
            </div>
            <Badge variant="outline" className="bg-success/10 text-success border-success/20">
              Good
            </Badge>
          </div>
          <p className="text-sm text-muted-foreground mb-1">Data Quality</p>
          <p className="text-3xl font-bold">95%</p>
        </Card>

        <Card className="p-6">
          <div className="flex items-start justify-between mb-3">
            <div className="p-3 rounded-xl bg-warning/10">
              <AlertTriangle className="w-6 h-6 text-warning" />
            </div>
            <Badge variant="outline" className="bg-warning/10 text-warning border-warning/20">
              Review
            </Badge>
          </div>
          <p className="text-sm text-muted-foreground mb-1">Duplicates</p>
          <p className="text-3xl font-bold">3</p>
        </Card>

        <Card className="p-6">
          <div className="flex items-start justify-between mb-3">
            <div className="p-3 rounded-xl bg-destructive/10">
              <FileWarning className="w-6 h-6 text-destructive" />
            </div>
            <Badge variant="outline" className="bg-destructive/10 text-destructive border-destructive/20">
              Action Needed
            </Badge>
          </div>
          <p className="text-sm text-muted-foreground mb-1">Missing Fields</p>
          <p className="text-3xl font-bold">12</p>
        </Card>

        <Card className="p-6">
          <div className="flex items-start justify-between mb-3">
            <div className="p-3 rounded-xl bg-primary/10">
              <Clock className="w-6 h-6 text-primary" />
            </div>
          </div>
          <p className="text-sm text-muted-foreground mb-1">Last Scan</p>
          <p className="text-3xl font-bold">2h</p>
          <p className="text-xs text-muted-foreground mt-1">ago</p>
        </Card>
      </div>

      {/* Data Integrity */}
      <Card className="p-6">
        <div className="flex items-center gap-3 mb-4">
          <Database className="w-5 h-5 text-primary" />
          <h3 className="text-lg font-semibold">Data Integrity</h3>
        </div>
        <div className="space-y-3">
          <div className="flex items-center justify-between p-3 rounded-lg bg-muted/50">
            <span className="text-sm">Lead Records</span>
            <Badge variant="outline" className="bg-success/10 text-success">Valid</Badge>
          </div>
          <div className="flex items-center justify-between p-3 rounded-lg bg-muted/50">
            <span className="text-sm">Job Records</span>
            <Badge variant="outline" className="bg-success/10 text-success">Valid</Badge>
          </div>
          <div className="flex items-center justify-between p-3 rounded-lg bg-muted/50">
            <span className="text-sm">Contact Information</span>
            <Badge variant="outline" className="bg-warning/10 text-warning">Needs Review</Badge>
          </div>
        </div>
      </Card>

      {/* Quick Actions */}
      <Card className="p-6">
        <h3 className="text-lg font-semibold mb-4">Quick Actions</h3>
        <div className="flex flex-wrap gap-3">
          <Button variant="outline">Run Full Scan</Button>
          <Button variant="outline">Find Duplicates</Button>
          <Button variant="outline">Validate All Records</Button>
          <Button variant="outline">Export Report</Button>
        </div>
      </Card>
    </div>
  );
}
